import Settings from 'feature/settings/settings';

export default Settings;
